import DocumentsTable from './Table';

export default DocumentsTable;
